import { render, staticRenderFns } from "./GiftcardList2.vue?vue&type=template&id=2830adce&scoped=true&"
import script from "./GiftcardList2.vue?vue&type=script&lang=js&"
export * from "./GiftcardList2.vue?vue&type=script&lang=js&"
import style0 from "./GiftcardList2.vue?vue&type=style&index=0&id=2830adce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2830adce",
  null
  
)

export default component.exports